import { pipe } from "fp-ts/function";
import * as L from "monocle-ts/Lens";
import { FeatureFlagControllerState } from "controllers/FeatureFlagController/FeatureFlagControllerState";
import { FavoriteAssetsControllerState } from "./FavoriteAssetsControllerState";

export const FavoriteAssetsL = pipe(
  L.id<FavoriteAssetsControllerState>(),
  L.prop("favoriteAssets")
);
